import { state } from '../lib/state.js';
import { drawRoute } from '../ui/map.js';
import { els } from './dom.js';
import { pointsForCurrentView } from '../routes/route-plan.js';

export function setTopNavigation(workspace) {
  els.newRouteNavBtn?.classList.toggle('active', workspace === 'route');
  els.reportsNavBtn?.classList.toggle('active', workspace === 'reports');
  els.diagnosticsBtn?.classList.toggle('active', workspace === 'diagnostics');
}

export function showWorkspace(workspace = 'route') {
  els.mainWorkspace?.classList.toggle('hidden', workspace !== 'route');
  els.reportsWorkspace?.classList.toggle('hidden', workspace !== 'reports');
  els.diagnosticsWorkspace?.classList.toggle('hidden', workspace !== 'diagnostics');
  setTopNavigation(workspace);
  if (workspace === 'route') {
    requestAnimationFrame(() => {
      const points = pointsForCurrentView();
      if (points.length) drawRoute(state.currentRoute);
    });
  }
}


